import { memo } from 'react'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

import { Notification } from 'checkout/components/Notification'

import * as S from './styled'

const UserInvalid = () => (
  <Notification type="danger">
    <Text size="kilo" noMargin>
      <Text as="strong" size="kilo" bold>Ops! O número registrado como CPF está incompleto.</Text>
      <br />
      Por favor, entre em contato com a nossa{' '}
      <S.Link href="https://www.leroymerlin.com.br/fale-conosco" target="_blank">
        Central de Atendimento
      </S.Link>{' '}
      para corrigir essa informação.
    </Text>
  </Notification>
)

export default memo(UserInvalid)
